export default __webpack_public_path__ + "static/media/use_action_xw.b1177a89.png";